import StyleIndex from "../../entities/GoogleSlidesStyleIndex";

export default class GoogleSlidesStyleIndexHelperMethods {
	static getStyleEndIndexes(indexes: number[]) {
		let endIndexes: number[] = [];
		for (let x = 0; x < indexes.length; x++) {
			let nextIndexIsNotNextSequentially = indexes[x] !== indexes[x + 1] + 1;
			if (nextIndexIsNotNextSequentially) {
				endIndexes.push(indexes[x]);
			}
		}
		return endIndexes;
	}

	static getStyleStartIndexes(indexes: number[]) {
		let startIndexes: number[] = [];
		for (let x = 0; x < indexes.length; x++) {
			let currentIndexIsNotNextSequentially = indexes[x] + 1 !== indexes[x - 1];

			if (x === 0) {
				startIndexes.push(indexes[x]);
			} else if (currentIndexIsNotNextSequentially) {
				startIndexes.push(indexes[x]);
			}
		}
		return startIndexes;
	}

	static getFontFamilyStartIndexes(indexes: StyleIndex[]) {
		let startIndexes: StyleIndex[] = [];
		for (let x = 0; x < indexes.length; x++) {
			if (indexes[x + 1] == null) {
				startIndexes.push(indexes[x]);
				continue;
			}
			let nextIndexIsNotNextSequentially = indexes[x].index !== indexes[x + 1].index + 1;
			let nextFontFamilyIsDiff = indexes[x].fontFamily !== indexes[x + 1].fontFamily;
			if (nextIndexIsNotNextSequentially || nextFontFamilyIsDiff) {
				startIndexes.push(indexes[x]);
			}
		}
		return startIndexes;
	}

	static getFontFamilyEndIndexes(indexes: StyleIndex[]) {
		let endIndexes: StyleIndex[] = [];
		for (let x = 0; x < indexes.length; x++) {
			if (x === 0) {
				endIndexes.push(indexes[x]);
				continue;
			}

			let prevIndexNumberIsNotNextSequentially = indexes[x - 1].index !== indexes[x].index + 1;
			let prevFontFamilyIsDiffFromCurrent = indexes[x - 1].fontFamily !== indexes[x].fontFamily;
			if (prevIndexNumberIsNotNextSequentially || prevFontFamilyIsDiffFromCurrent) {
				endIndexes.push(indexes[x]);
			}
		}
		return endIndexes;
	}

	static getFontSizeStartIndexes(indexes: StyleIndex[]) {
		let startIndexes: StyleIndex[] = [];
		for (let x = 0; x < indexes.length; x++) {
			if (indexes[x + 1] == null) {
				startIndexes.push(indexes[x]);
				continue;
			}
			let nextIndexIsNotNextSequentially = indexes[x].index !== indexes[x + 1].index + 1;
			let nextFontSizeIsDiff = indexes[x].fontSize !== indexes[x + 1].fontSize;
			if (nextIndexIsNotNextSequentially || nextFontSizeIsDiff) {
				startIndexes.push(indexes[x]);
			}
		}
		return startIndexes;
	}

	static getFontSizeEndIndexes(indexes: StyleIndex[]) {
		let endIndexes: StyleIndex[] = [];
		for (let x = 0; x < indexes.length; x++) {
			if (x === 0) {
				endIndexes.push(indexes[x]);
				continue;
			}

			let prevIndexNumberIsNotNextSequentially = indexes[x - 1].index !== indexes[x].index + 1;
			let prevFontSizeIsDiffFromCurrent = indexes[x - 1].fontSize !== indexes[x].fontSize;
			if (prevIndexNumberIsNotNextSequentially || prevFontSizeIsDiffFromCurrent) {
				endIndexes.push(indexes[x]);
			}
		}
		return endIndexes;
	}

	static getTextBackgroundColorStartIndexes(indexes: StyleIndex[]) {
		let startIndexes: StyleIndex[] = [];
		for (let x = 0; x < indexes.length; x++) {
			if (indexes[x + 1] == null) {
				startIndexes.push(indexes[x]);
				continue;
			}
			let nextIndexIsNotNextSequentially = indexes[x].index !== indexes[x + 1].index + 1;
			let nextBackgroundColorIsDiff = indexes[x].backgroundColor !== indexes[x + 1].backgroundColor;
			if (nextIndexIsNotNextSequentially || nextBackgroundColorIsDiff) {
				startIndexes.push(indexes[x]);
			}
		}
		return startIndexes;
	}

	static getTextBackgroundColorEndIndexes(indexes: StyleIndex[]) {
		let endIndexes: StyleIndex[] = [];
		for (let x = 0; x < indexes.length; x++) {
			if (x === 0) {
				endIndexes.push(indexes[x]);
				continue;
			}

			let prevIndexNumberIsNotNextSequentially = indexes[x - 1].index !== indexes[x].index + 1;
			let prevBgColorIsDiffFromCurrent = indexes[x - 1].backgroundColor !== indexes[x].backgroundColor;
			if (prevIndexNumberIsNotNextSequentially || prevBgColorIsDiffFromCurrent) {
				endIndexes.push(indexes[x]);
			}
		}
		return endIndexes;
	}
}
